const QUERIES = {
  USERS_LIST: 'users-list',
  COMPANIES_LIST: 'companies-list',
  COMPANY_DETAILS: 'company-details',
  SITES_LIST: 'sites-list',
  WAYBILLS_LIST: 'waybills-list',
  HEARTBEAT: 'heartbeat',
  BATCH_LIST: 'batch-list',
  BATCH_STATUS: 'batch-status',
}

enum EBATCH_STATUS {
  STATUS_UNKNOWN = 'STATUS_UNKNOWN',
  STATUS_PROCESSING_BATCH = 'STATUS_PROCESSING_BATCH',
  STATUS_NOT_PROCESSING_BATCH = 'STATUS_NOT_PROCESSING_BATCH',
}

export { QUERIES, EBATCH_STATUS }
